import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";

export default function EmbeddedExitConfirmDialog({
  open,
  onConfirm,
  onCancel,
  brandName = "this application",
  storagePrefix = "embedded",
}) {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const handleConfirm = () => {
    if (dontAskAgain) {
      try {
        localStorage?.setItem(`${storagePrefix}ExitConfirmDisabled`, "true");
      } catch (error) {
        console.warn("Failed to save exit confirmation preference:", error);
      }
    }
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="embedded-exit-title"
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 1,
        },
      }}
    >
      <DialogTitle id="embedded-exit-title">
        <Typography variant="h6" component="h2">
          You are leaving {brandName}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          You are leaving {brandName}... press to continue
        </Typography>
        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={dontAskAgain}
                onChange={(e) => setDontAskAgain(e.target.checked)}
                color="primary"
              />
            }
            label="Don't ask again"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          color="primary"
          sx={{ mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          autoFocus
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
